module.exports = __webpack_public_path__ + "static/Yakshof-6d8711ba39cd8c1ad97efb2b45831ef2.png";